import PropTypes from 'prop-types';

import FilterChipsBar from '#globalComponents/Table/FilterChipsBar';
import TableSearchInput from '#globalComponents/Table/filters/TableSearchInput';
import { buildFilterChips } from '#lib/tableFilters';

/** Search input + active-filter chips above a table whose filters come from useUrlFilters. */
const TableFilterToolbar = ({ urlFilters, schema, searchPlaceholder, resultLabel }) => {
	const { filters, setFilters, removeFilters, clearFilters } = urlFilters;

	return (
		<>
			<TableSearchInput
				value={filters.search ?? ''}
				onChange={(search) => setFilters({ search })}
				placeholder={searchPlaceholder}
				className="mb-2.5 max-w-sm"
			/>
			<FilterChipsBar
				chips={buildFilterChips(filters, schema)}
				resultLabel={resultLabel}
				onRemove={removeFilters}
				onClearAll={clearFilters}
			/>
		</>
	);
};

TableFilterToolbar.propTypes = {
	urlFilters: PropTypes.shape({
		filters: PropTypes.object.isRequired,
		setFilters: PropTypes.func.isRequired,
		removeFilters: PropTypes.func.isRequired,
		clearFilters: PropTypes.func.isRequired,
	}).isRequired,
	schema: PropTypes.object.isRequired,
	searchPlaceholder: PropTypes.string.isRequired,
	resultLabel: PropTypes.string,
};

export default TableFilterToolbar;
